module.exports = __webpack_public_path__ + "static/media/icon-star-purple.9ae087e8.svg";